var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "faq-list" },
    _vm._l(_vm.faqsMapped, function (faqsInCategory, category) {
      return _c("div", { key: category, staticClass: "faq-category" }, [
        _c("h3", { staticClass: "category-title" }, [
          _vm._v("\n      " + _vm._s(_vm.categoryLabels[category]) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "faqs" },
          _vm._l(faqsInCategory, function (faq) {
            return _c(
              "div",
              {
                key: faq.id,
                staticClass: "faq",
                class: { expanded: _vm.isExpanded(faq) },
              },
              [
                _c(
                  "div",
                  { staticClass: "faq-heading" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "faq-heading-content",
                        on: {
                          click: function ($event) {
                            return _vm.toggleExpand(faq)
                          },
                        },
                      },
                      [
                        _c("h4", { staticClass: "faq-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(faq.title) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "faq-expand-icon" },
                          [_c("chevron-right")],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("node-element-local-tasks", {
                      attrs: {
                        itemid: faq.id,
                        options: { mode: "view", destination: "/faqs" },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isExpanded(faq)
                  ? _c("div", { staticClass: "faq-content" }, [
                      _c("div", {
                        staticClass: "faq-body",
                        domProps: { innerHTML: _vm._s(faq.body) },
                      }),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }